import { useState, useEffect } from "react";
import { DynamicForm } from "../DynamicForm";
import Datas from "../../utils/individualQuestions.json";
import { BackgroundForm } from "../individualComponents/backgroundForm";
import { Link } from "react-router-dom";
import { SelectLocationDropdown } from "../SelectLocationDropdown";

type QuestionItem = {
  question: string;
  answer: string | null;
};

type CategoryItem = {
  category: string;
  questions: QuestionItem[];
};
type Location = {
  aimag: string;
  sum: string;
  bag: string;
};
export const IndividualPage = () => {
  const [location, setLocation] = useState<Location | null>(null);
  const [currentCategory, setCurrentCategory] = useState<string>("location");
  const [selectedAimag, setSelectedAimag] = useState<string>("");
  const [selectedSum, setSelectedSum] = useState<string>("");
  const [selectedBag, setSelectedBag] = useState<string>("");
  const [questions, setQuestions] = useState<CategoryItem[] | null>(null);

  const handlePreviousCate = () => {
    if (currentCategory === "form") {
      setCurrentCategory("location");
    }
  };
  const handleNext = () => {
    if (questions !== null) {
      if (
        selectedBag !== "" &&
        currentCategory === "location" &&
        questions[0].questions.every((e) => e.answer != null)
      ) {
        setCurrentCategory("form");
      }
    }
  };
  const sendAnswer = () => {
    if (questions !== null) {
      if (questions[1].questions.every((e) => e.answer != null)) {
        return location;
      }
    }
  };

  useEffect(() => {
    setQuestions(Datas as CategoryItem[]);
  }, []);
  useEffect(() => {
    setLocation({
      aimag: selectedAimag,
      sum: selectedSum,
      bag: selectedBag,
    });
  }, [selectedBag, selectedSum, selectedAimag]);

  return (
    <div className="min-h-screen w-full bg-gray-50 py-6 sm:py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <Link
            to="/forum"
            className="inline-flex items-center text-gray-600 hover:text-amber-600 transition-colors font-medium bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100"
          >
            ← Буцах
          </Link>
        </div>

        <div className="bg-white rounded-2xl overflow-hidden border border-gray-100">
          <div className="px-4 py-6 sm:px-10 bg-amber-500 text-white text-center">
            <h1 className="text-sm sm:text-xl font-bold leading-relaxed">
              Иргэний гамшгаас хамгаалах ойлголт, мэдлэгийг шалгах асуумж
            </h1>
          </div>

          <div className="px-6 py-8 sm:px-10">
            {/* Progress Bar */}
            <div className="w-full h-3 bg-gray-100 rounded-full mb-8 overflow-hidden">
              <div
                className={`bg-amber-500 h-full rounded-full transition-all duration-500 ease-out ${
                  currentCategory === "location" ? "w-1/2" : "w-11/12"
                }`}
              />
            </div>

            {/* Step 1: Location & Background */}
            {currentCategory === "location" && (
              <div className="space-y-8 animate-fadeIn">
                <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-amber-100 text-amber-600 text-sm font-bold">
                      1
                    </span>
                    Иргэний оршин сууж буй хаягийн мэдээлэл
                  </h3>
                  <SelectLocationDropdown
                    setSelectedAimag={setSelectedAimag}
                    selectedAimag={selectedAimag}
                    setSelectedSum={setSelectedSum}
                    selectedSum={selectedSum}
                    setSelectedBag={setSelectedBag}
                    selectedBag={selectedBag}
                  />
                </div>

                {questions && (
                  <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="flex items-center justify-center w-8 h-8 rounded-full bg-amber-100 text-amber-600 text-sm font-bold">
                        2
                      </span>
                      Ерөнхий мэдээлэл
                    </h3>
                    <BackgroundForm
                      questions={questions}
                      setQuestions={setQuestions}
                    />
                  </div>
                )}
              </div>
            )}

            {/* Step 2: Main Form */}
            {currentCategory === "form" && questions && (
              <div className="animate-fadeIn space-y-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-6 border-b pb-4">
                  Гамшгаас хамгаалах мэдлэг
                </h3>
                <DynamicForm
                  categoryData={questions[1]}
                  setAllCategories={setQuestions}
                />
              </div>
            )}

            {/* Footer Buttons */}
            <div className="mt-10 pt-6 border-t border-gray-100 flex justify-between items-center">
              {currentCategory !== "location" ? (
                <button
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    handlePreviousCate();
                  }}
                  className="px-6 py-2.5 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-xl font-semibold transition-colors"
                >
                  Өмнөх
                </button>
              ) : (
                <div></div>
              )}

              {currentCategory === "form" ? (
                <button
                  onClick={sendAnswer}
                  className="px-6 py-2.5 bg-green-600 text-white shadow-lg shadow-green-200 hover:bg-green-700 rounded-xl font-semibold transition-all transform hover:-translate-y-0.5"
                >
                  Хариултыг илгээх
                </button>
              ) : (
                <button
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    handleNext();
                  }}
                  className="px-6 py-2.5 bg-amber-500 text-white shadow-lg shadow-amber-200 hover:bg-amber-600 rounded-xl font-semibold transition-all transform hover:-translate-y-0.5"
                >
                  Дараах
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
